import React from "react";

type Props = {
  label: string | React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  style?: React.CSSProperties | undefined;
  mode?: "dark" | "light";
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean | undefined;
};
const AuthButton = ({
  label,
  style,
  onClick,
  mode = "light",
  type,
  disabled,
}: Props) => {
  return (
    <button
      type={type}
      style={style}
      className={`auth_button ${mode === "dark" ? "auth_button_dark" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default AuthButton;
